import { isProjectFeatureEnabled } from './lensFeatures';

/** Overview cards and rows map to the same keys as sidebar / FeatureProtectedRoute. */
export function buildOverviewFeatureFlags(enabledFeatures) {
    const on = featureKey => isProjectFeatureEnabled(enabledFeatures, featureKey);

    const projectManagement = on('project_management');
    const raidLog = on('raid_log');
    const actionLog = on('action_log');
    const lessonsLearnt = on('lessons_learnt');
    const journal = on('journal');
    const lensIntelligence = on('lens_intelligence');
    const observations = on('observations');
    const indexScores =
        on('maturity_index') || on('security_index') || on('team_analyser') || on('security_governance');

    return {
        informationRequests: on('information_requests'),
        dataroom: on('dataroom'),
        observations,
        lensIntelligence,
        swot: observations,
        indexScores,
        projectManagement,
        raidLog,
        actionLog,
        lessonsLearnt,
        journal,
        deliveryGovernance: projectManagement || raidLog || actionLog,
        projectKnowledge: lessonsLearnt || journal,
        showExtendedInsights: lensIntelligence || observations || indexScores,
    };
}
